const mediaGridShowFirstPage = document.getElementById("show_page-1");
const mediaGridShowSecondPage = document.getElementById("show_page-2");

const firstPageItems = document.getElementsByClassName("media-grid--item_first-page");
const secondPageItems = document.getElementsByClassName("media-grid--item_second-page");

mediaGridShowFirstPage.addEventListener("click", function() {
  mediaGridShowFirstPage.classList.add("active");
  mediaGridShowSecondPage.classList.remove("active");

    for (let i = 0; i < secondPageItems.length; i++) {
      secondPageItems[i].style.display = "none";
    }

    for (let j = 0; j < firstPageItems.length; j++) {
      firstPageItems[j].style.display = "flex";
    }
  });

  mediaGridShowSecondPage.addEventListener("click", function() {
  mediaGridShowFirstPage.classList.remove("active");
  mediaGridShowSecondPage.classList.add("active");
    
    for (let i = 0; i < firstPageItems.length; i++) {
      firstPageItems[i].style.display = "none";
    }

    for (let j = 0; j < secondPageItems.length; j++) {
      secondPageItems[j].style.display = "flex";
    }
  });